/**
 * CssLoader.
 */
export default class CssLoader {
	private element = document.createElement('link');

	/**
	 *
	 * @param url Url to css file.
	 */
	constructor(url: string) {
		this.element.href = url;
	}
	/**
	 * Load a css file by adding a link tag.
	 *
	 * @returns Promise event.
	 *
	 */
	public load(): Promise<Event> {
		return new Promise((resolve, reject) => {
			this.element.addEventListener('load', resolve);
			this.element.addEventListener('error', reject);
			this.element.setAttribute('type', 'text/css');
			this.element.setAttribute('rel', 'stylesheet');
			document.head.appendChild(this.element);
		});
	}
}
